// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"deeef7f7","455":"e5b36265","977":"6b4ada5d"}[chunkId] + ".chunk.js";
};